/**
 * @module BandNode
 * 
 */
define(function () {
    /**
     * @class
     * Store information for each spectra band of a species
     * @param {number} wavelength - wavelength of the center of the band
     * @param {number} width - half-width of the band
     * @param {number} e - peak height
     */
    BandNode = function (wavelength, width, e) {
        this.wavelength = wavelength;
        this.width = width;
        this.e = e;
    };
    return BandNode;
});
